import { Label } from "../label";

type Props = {
  name: string;
  label: string;
  value?: string;
  defaultValue?: string;
  placeholder?: string;
  header?: boolean;
  required?: boolean;
  disabled?: boolean;
};

export default function TextArea({
  name,
  label,
  value,
  defaultValue,
  placeholder,
  header = true,
  required,
  disabled,
}: Props) {
  return (
    <div className="flex items-center">
      {header && (
        <div className="w-3/12">
          <Label name={name} label={label} required={required} />
        </div>
      )}

      <div className="relative w-8/12">
        <textarea
          className={`block h-10 min-h-[42px] w-full resize-none rounded-md border border-gray-300 py-2 px-3 font-input text-input shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 ${
            disabled ? "bg-stone-100" : "bg-white"
          }`}
          defaultValue={defaultValue}
          name={name}
          id={name}
          value={value}
          placeholder={placeholder}
          autoComplete="given-name"
          disabled={disabled}
        />
      </div>
    </div>
  );
}
